// BSV CHANGES 
import {call, put, takeLatest} from 'redux-saga/effects';
import {NetworkService, ToasterService} from '@app/services';
import {
  getDistanceRequest,
  getDistanceSuccess,
  getDistanceFailure,
  postDistanceRequest,
  postDistanceSuccess,
  postDistanceFailure,
} from './slice';
import {API_PATH} from '@app/common/constants';
import { ToastType } from '@app/services/toaster';

function* handleGetDistance(action: ReturnType<typeof getDistanceRequest>): any {
  try {
    const url = API_PATH.expenseDistance.getDistanceAPI;
    const qs = new URLSearchParams(action.payload).toString();
    const fullUrl = `${url}?${qs}`;
    const response: { data: any } = yield call(() =>
      NetworkService.get(fullUrl, {}, {})
    );
    yield put(getDistanceSuccess(response.data));
  } catch (error: any) {
    console.error("Distance API Error:", error);
    yield put(getDistanceFailure(error.message));
  }
}

function* handlePostDistance(action: ReturnType<typeof postDistanceRequest>): any {
  try {
    const url = API_PATH.expenseDistance.updateDistanceAPI;
    yield call(NetworkService.post, url, action.payload); // assuming payload is request body
    yield put(postDistanceSuccess());
    ToasterService.showToaster(
      'Records updated successfully in Expense distance master.',
      ToastType.SUCCESS,
    );
  } catch (error: any) {
    yield put(postDistanceFailure(error.message));
    ToasterService.showToaster(
      'Something went wrong while updating Expense distance master.',
      ToastType.ERROR,
    );
  }
}

export default function* expenseDistanceSaga() {
  yield takeLatest(getDistanceRequest.type, handleGetDistance);
  yield takeLatest(postDistanceRequest.type, handlePostDistance);
}
